import constants from "constants";
import React, { Component } from "react";
import { connect } from "react-redux";
import { loadCurrentWebinarsSaga } from "../../../../actions/api";
import { cleanWebinars } from "../../../../actions/webinars";
import CurrentWebinars from "./CurrentWebinars";

const { CURRENT_WEBINARS } = constants;

class StudyGroupSuperhostCurrentWebinars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      group_id: props.params.id,
    };
  }

  componentDidMount() {
    this.props.loadCurrentWebinars(this.state.page, {
      group_id: this.state.group_id,
    });
  }

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  handlePageChange = () =>
    this.setState({ page: this.state.page + 1 }, () =>
      this.props.loadCurrentWebinars(this.state.page, {
        group_id: this.state.group_id,
      })
    );

  handleRefreshWebinars = () =>
    this.props.loadCurrentWebinars(this.state.page, {
      group_id: this.state.group_id,
    });

  render() {
    return (
      <CurrentWebinars
        webinars={this.props.current.values}
        nextPage={this.handlePageChange}
        page={this.state.page}
        count={this.props.current.count}
        onRefreshWebinars={this.handleRefreshWebinars}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    current: state.webinars[CURRENT_WEBINARS],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadCurrentWebinars: (page, params) =>
      dispatch(loadCurrentWebinarsSaga(page, params)),
    cleanWebinars: () => dispatch(cleanWebinars()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostCurrentWebinars);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Current/StudyGroupSuperhostCurrentWebinars.jsx